/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */
import {
  Asset,
  Stream,
  PlaybackLicenseData,
  PlaybackLicenseResult,
  PlaybackContextApi,
  PlaybackAssetType,
  XError,
  GetPlaybackContextErrors,
  Ducks,
} from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';

function* getPlaybackData(asset: Asset, stream: Stream): SagaIterator<PlaybackLicenseData> {
  const result: PlaybackLicenseResult = yield Ducks.Api.callApi(
    PlaybackContextApi.getPlaybackData,
    asset.id,
    PlaybackAssetType.MEDIA,
    stream.id
  );

  // For VOD content (movies and episodes) the authZ token it's mandatory for non clear content
  if (!result.clearContent && (!result.data.token || result.data.token === '')) {
    throw XError.fromCode(GetPlaybackContextErrors.validation.invalidDrmData);
  }

  return result.data;
}

function* getPlaybackLicenseLink(asset: Asset, stream: Stream): SagaIterator<PlaybackLicenseResult> {
  return yield Ducks.Api.callApi(PlaybackContextApi.getPlaybackUrl, asset.id, PlaybackAssetType.MEDIA, stream.id);
}

export default {
  getPlaybackData,
  getPlaybackLicenseLink,
};
